const wait = (ms: number) => new Promise((r) => setTimeout(r, ms));

export function retryOperation<T>(
    operation: () => Promise<T>,
    delay: number = 250,
    retries: number = 3,
): Promise<T> {
    return new Promise((resolve, reject) =>
        operation()
            .then(resolve)
            .catch((reason) => {
                if (retries > 0) {
                    return wait(delay)
                        .then(() => retryOperation<T>(operation, delay, retries - 1))
                        .then(resolve)
                        .catch(reject);
                }

                return reject(reason);
            }),
    );
}
